// Function to toggle dropdown visibility
function showFunction(e) {
    if (!document.getElementById(e).classList.contains("show")) {
        document.getElementById(e).classList.toggle("show");
    }
}

// Function to handle focus out
function multiFilterFunctionFocusOut(i) {
    document.getElementById(i).classList.toggle("show");
}

// Function to open filter dropdown
function multiFilterFunction(i) {
    showFunction(i);
}

// Function to manage multi-select behavior
function multiSelectFunction(e, id, j, isSelectAll = false) {
    let input = document.getElementById(id);
    let selected = input.value ? input.value.split(",") : [];

    if (e.checked) {
        selected.push(e.value);
    } else {
        selected = selected.filter(val => val.trim() !== e.value);
    }

    input.value = selected.map(val => val.trim()).join(", ");
    let labelCount = document.querySelectorAll(`#${j} input[type="checkbox"]:not(#SelectAll-${j})`).length;
    let selectedCount = document.querySelectorAll(`#${j} input[type="checkbox"]:not(#SelectAll-${j}):checked`).length;
    
    document.getElementById(`multiselectInputCount-${id}`).textContent = selectedCount;

    if (!isSelectAll) {
        document.getElementById(`SelectAll-${j}`).checked = (labelCount === selectedCount);
    }
}

// Function to handle "Select All" checkbox
function multiselectSelectAll(obj, id, j) {
    let checkboxes = document.querySelectorAll(`#${j} input[type="checkbox"]:not(#SelectAll-${j})`);
    checkboxes.forEach(checkbox => {
        checkbox.checked = obj.checked;
        multiSelectFunction(checkbox, id, j, true);
    });
}

